var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorona(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#4b4495;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b{fill:#48d1cc;}.c{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.1,25.067s6.421-2.145,5.533,3.2A7.994,7.994,0,0,1,33.1,34.694m-21.4-9.627s-6.421-2.145-5.533,3.2a7.994,7.994,0,0,0,5.533,6.427",
    transform: "translate(-4.647 -20.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.255,33.834s-2.6,2.536-10.628,2.536S15,33.834,15,33.834v-11.5A21.23,21.23,0,0,1,25.628,19.58a21.23,21.23,0,0,1,10.628,2.759Z",
    transform: "translate(-8.071 -18.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.255,26.883s-2.6,1.3-10.628,1.3S15,26.883,15,26.883v-5.89a38.091,38.091,0,0,1,10.628-1.414,38.091,38.091,0,0,1,10.628,1.414Z",
    transform: "translate(-8.071 -15.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M36.255,27.249S33.655,26,25.628,26,15,27.249,15,27.249V25.8a40.441,40.441,0,0,1,10.628-1.3,40.441,40.441,0,0,1,10.628,1.3ZM15,31.125s2.6,1.25,10.628,1.25,10.628-1.25,10.628-1.25v1.451a40.441,40.441,0,0,1-10.628,1.3A40.441,40.441,0,0,1,15,32.576Z",
    transform: "translate(-8.071 -20.187)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 36,
    height: 18,
    transform: "translate(-0.071)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorona);
export default __webpack_public_path__ + "static/media/corona.380f05cc42665f49f3034531b788b831.svg";
export { ForwardRef as ReactComponent };